<template>
  <div>
    <!-- 编辑、添加 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible">
      <el-form :model="vinAccountForm" :rules="vinAccountFormRules" ref="vinAccountFormRef" label-width="80px">
        <el-row type="flex" class="row-bg" justify="space-around" :gutter="24">
          <el-col :span="12">
            <!-- 内容主体区域 -->
            <el-form-item label="提现商户" prop="totalLedgerId">
              <el-select v-model="vinAccountForm.totalLedgerId" @change="changeStationMethods">
                <el-option v-for="item in allshanghu" :key="item.id" :value="item.id"
                  :label="item.trueName"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="账户性质" prop="accountKind">
              <el-select v-model="vinAccountForm.accountKind" @change="changeStationMethods">
                <el-option v-for="item in kind" :key="item.accountKind" :value="item.accountKind"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item> -->
            <!-- @change="changeStationMethods" -->
            <el-form-item label="证件类型" prop="certType">
              <el-select v-model="vinAccountForm.certType">
                <el-option v-for="item in centterType" :key="item.certType" :value="item.certType"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <!-- v-if="vinAccountForm.acctType == 0" -->
            <el-form-item label="联行号" prop="bankBranchNo" v-if="vinAccountForm.acctType == 0" required>
              <el-input v-model="vinAccountForm.bankBranchNo"></el-input>
            </el-form-item>
            <el-form-item label="收款卡号" prop="bankCard">
              <el-input v-model="vinAccountForm.bankCard"></el-input>
            </el-form-item>
            <!-- :disabled="title !== '分佣商户'" -->
            <el-form-item label="登录账户" prop="userName" required>
              <el-input v-model="vinAccountForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="trueName">
              <el-input v-model="vinAccountForm.trueName"></el-input>
            </el-form-item>

            <!-- 是否主账户 -->
          </el-col>
          <el-col :span="12">
            <el-form-item label="主账户" prop="isMainAccount">
              <el-radio-group v-model="vinAccountForm.isMainAccount">
                <el-radio v-for="item in leaavel" :key="item.isMainAccount" :label="item.isMainAccount">{{ item.name
                  }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="账户类型" prop="acctType">
              <el-select v-model="vinAccountForm.acctType">
                <el-option v-for="item in accList" :key="item.acctType" :value="item.acctType"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开户行号" prop="bankNo" required>
              <el-input v-model="vinAccountForm.bankNo"></el-input>
            </el-form-item>
            <el-form-item label="收款银行" prop="bankName">
              <el-input v-model="vinAccountForm.bankName"></el-input>
            </el-form-item>
            <el-form-item label="支行名称" prop="bankBranchName">
              <el-input v-model="vinAccountForm.bankBranchName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="vinAccountForm.phone"></el-input>
            </el-form-item>
            <!-- 是否主账户 -->
            <!-- :disabled="title !== '分佣商户'" -->
            <!-- :disabled="title !== '分佣商户'" -->
            <el-form-item label="登录密码" prop="passWord">
              <el-input v-model="vinAccountForm.passWord"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注说明" prop="des">
          <el-input v-model="vinAccountForm.des"></el-input>
        </el-form-item>
        <div>
          <!-- && title == '编辑商户' -->
          <div v-for="(items, index) in objValue" :key="items.uniqueId">
            <el-row :gutter="24">
              <el-col :span="7">
                <el-form-item label="所属电站" prop="stationId">
                  <el-select v-model="items.stationId" @change="currentMethods" filterable>
                    <el-option v-for="item in stationList" :key="item.id" :value="item.id" :label="item.stationName"
                      filterable></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="收费类型" prop="type">
                  <el-select v-model="items.type">
                    <el-option v-for="item in typelist" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="费率" prop="serviceRate">
                  <el-input-number v-model="items.serviceRate" controls-position="right" :min="0"
                    :max="100"></el-input-number>
                  <span style="margin-left: 8px">%</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-button style="margin-left: 20px" @click="delObj(index)" type="danger">删除</el-button>
              </el-col>
            </el-row>
          </div>
          <el-button style="margin-left: 40%" @click="addObj" v-if="objValue.length < 6">添加电站</el-button>
        </div>
      </el-form>
      <!-- 底部按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogClosed">取 消</el-button>
        <el-button type="primary" v-debounce="editVinAccount">确 定</el-button>
      </span>
    </el-dialog>
    <el-row :gutter="20" style="padding-bottom: 10px">
      <el-col :span="3" label="" style="display: flex; flex-direction: row; align-items: center">
        <span style="font-size: 14px; width: 110px; padding-right: 10px">清分人</span>
        <el-select v-model="suoshudianzhan" placeholder="请选择清分人" @change="change_value" filterable>
          <el-option v-for="item in powerStationList" :key="item.id" :label="item.merchantName" :value="item.id">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" @click="chaxun">查询</el-button>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-refresh-left" @click="chongzhi">重置</el-button>
      </el-col>
      <!-- <el-col :span="2">
          <el-button type="primary" icon="el-icon-refresh-left" @click="daochu">导出</el-button>
        </el-col> -->
    </el-row>


    <el-card>
      <li style="
          display: flex;
          justify-content: flex-end;
          margin: -10px 0 10px -1%;
        ">
        <el-button v-if="ownAcount" type="success" icon="el-icon-plus" @click="showVinAccount">分佣商户</el-button>
        <el-button v-if="daochuType" type="primary" @click="daochuMethods">导出</el-button>
      </li>
      <el-table :data="vinAccountList" border>
        <el-table-column align="center" label="清分人姓名" prop="trueName" width="100">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.trueName) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否主账户" prop="isMainAccount" width="100">
          <template slot-scope="scope">
            <span>
              {{ typename1(scope.row.isMainAccount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="账户类型" prop="acctType" width="100">
          <template slot-scope="scope">
            <span :style="stylecss(scope.row.acctType)">
              {{ typename2(scope.row.acctType) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="收款卡号" prop="bankCard" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.bankCard) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号" prop="phone" width="110">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.phone) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分比例" prop="serviceRate" width="80">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.serviceRate) + '%' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分金额" prop="freezeMoney" width="80">
          <template slot-scope="scope">
            <span> ￥{{ jisuan(scope.row.freezeMoney, 100, 2) }} </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="清分商户" prop="totalMerchantMame" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.totalMerchantMame) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="登录名称" prop="userName" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.userName) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="更新时间" prop="updateTime" width="100">
          <template slot-scope="scope">
            <span>
              {{ typeName(scope.row.updateTime) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作（禁用状态下不可提现）" v-if="caozuoquanxian" width="580" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" :disabled="scope.row.b_j_anniu"
              @click="showVinAccount(scope.row)" v-if="ownAcount">编辑</el-button>
            <el-button size="mini" type="success" icon="el-icon-plus" @click="uploadTil(scope.row)"
              v-if="ownAcount">上传</el-button>
            <el-button size="mini" type="warning" :disabled="scope.row.b_j_anniu"
              @click="detailMethods(scope.row)">清分明细</el-button>
            <el-button size="mini" icon="el-icon-s-help" type="danger" @click="moneyMethods(scope.row)"
              v-if="StopMoney">冻结金额</el-button>
            <el-button size="mini" icon="el-icon-turn-off" v-if="(typings && stopAccountStatus) ||
      (scope.row.isMainAccount !== 0 && stopAccountStatus)
      " :type="scope.row.status == 1 ? 'success' : 'danger'" :disabled="scope.row.b_j_anniu"
              @click="stopMethods(scope.row)">{{ scope.row.status == 1 ? '启用' : '停用' }}</el-button>
            <el-button size="mini" icon="el-icon-s-help" type="danger" @click="delMethods(scope.row)">删除附件</el-button>
            <el-button size="mini" icon="el-icon-s-help" type="danger" @click="delRole(scope.row)">删除清分人</el-button>

            <!-- <el-button size="mini" v-if=""
              :type="scope.row.status == 1 ? 'success' : 'danger'" :disabled="scope.row.b_j_anniu"
              @click="stopMethods(scope.row)">{{ scope.row.status == 1 ? '启用' : '停用' }}</el-button> -->
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <span>暂无数据</span>
        </div>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[6, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import caozuo from '@/utils/pubilc.js'
const acn = [5, 11, 17, 18];
export default {
  name: '',
  components: {

  },
  mixins: [],
  props: {

  },
  data() {
    return {
      dialogFormVisible: false,
      accList: [
        {
          acctType: 0,
          name: '对公(金融机构开设的公司账户)',
        },
        {
          acctType: 1,
          name: '对私(金融机构开设的私人账户)',
        },
      ],
      centterType: [
        {
          certType: 17,
          name: '身份证',
        },
        {
          certType: 18,
          name: '护照',
        },
        {
          certType: 19,
          name: '港澳临时通行证',
        },
        {
          certType: 20,
          name: '台湾临时通行证',
        },
        {
          certType: 22,
          name: '港澳居民居住证',
        },
        {
          certType: 23,
          name: '台湾居民身份证',
        },
      ],
      leaavel: [
        {
          isMainAccount: 0,
          name: '否',
        },
        {
          isMainAccount: 1,
          name: '是',
        },
      ],
      typelist: [
        {
          id: 0,
          name: '服务费',
        },
        {
          id: 1,
          name: '全额消费',
        }
      ],
      vinAccountFormRules: {
        trueName: {
          required: true,
          message: '请输入真实姓名',
          trigger: 'blur',
        },
        // bankBranchNo: {
        //   required: true, message: '请输入联行号', trigger: 'blur'
        // },
        bankBranchName: {
          required: true,
          message: '请输入支行名称',
          trigger: 'blur',
        },
        acctType: {
          required: true,
          message: '请选择账户类型',
          trigger: 'change',
        },
        // accountKind: {
        //   required: true, message: '请选择账户性质', trigger: 'change'
        // },
        certType: {
          required: true,
          message: '请选择证件类型',
          trigger: 'change',
        },
        merchantName: {
          required: true,
          message: '请输入商户名称',
          trigger: 'blur',
        },
        phone: {
          required: true,
          message: '请输入联系电话',
          trigger: 'blur',
        },
        totalLedgerId: {
          required: true,
          message: '请选择提现商户',
          trigger: 'change',
        },
        // stationId: {
        //   required: true, message: '请选择所属电站', trigger: 'change'
        // },
        bankCard: {
          required: true,
          message: '请输入收款卡号',
          trigger: 'blur',
        },
        bankName: {
          required: true,
          message: '请输入收款银行',
          trigger: 'blur',
        },
        // userName: {
        //   required: true, message: '请输入登录账户', trigger: 'blur'
        // },
        // passWord: {
        //   required: true, message: '请输入登录密码', trigger: 'blur'
        // }
      },
      vinAccountForm: {
        passWord: '',
        userName: '',
        adminId: '',
        trueName: '',
        id: '',
        bankCard: '',
        bankName: '',
        type: '',
        serviceRate: '',
        des: '',
        isMainAccount: 1,
        freezeMoney: '',
        totalLedgerId: '',
        stationId: '',
        serviceRateStr: null,
        typeStr: null,
        bankBranchName: '',
        bankBranchNo: '',
        acctType: 1,
        certType: 17,
        accountKind: 58,
        bankNo: '',
      }, objValue: [],
      title: '',
      powerStationList: [],
      suoshudianzhan: '',
      caozuoquanxian: false,
      daochuType: false,
      stopAccountStatus: false,
      StopMoney: false,
      ownAcount: false,
      quanxianlist: [100, 184, 185, 186, 198],
      vinAccountList: [],
      queryInfo: {
        stationId: null,
        page: 1,
        limit: 6,
        adminId: window.sessionStorage.getItem('adminId'),
        merchantName: '',
        totalLedgerId:
          window.sessionStorage.getItem('roleId') == 1
            ? 0
            : window.sessionStorage.getItem('stationTotalLedgerListId'),
      },
      currentinfo: {
        adminId: window.sessionStorage.getItem('adminId'),
        page: 1,
        limit: 100,
        id: null,
      },
      total: 0,
      typings: false,
      allshanghu: [],
      tilobj: {
        stationId: null,
        page: 1,
        limit: 200,
        adminId: window.sessionStorage.getItem('adminId'),
        merchantName: '',
        totalLedgerId:
          window.sessionStorage.getItem('roleId') == 1
            ? 0
            : window.sessionStorage.getItem('stationTotalLedgerListId'),
      },
    }
  },
  computed: {
    stylecss() {
      return (obj) => {
        const isSpecialType = obj == 0
        const obj1 = {
          color: isSpecialType ? 'red' : '#000',
        }
        return obj1
      }
    },
    shiji() {
      return function (abc, bac) {
        return ((abc * 1 + bac * 1) / 100).toFixed(2)
      }
    },
    wait_s() {
      return function (e) {
        return ((e.money - e.giveMoney) / 100).toFixed(2)
      }
    },
    time_all() {
      return function (val) {
        const hr = val.billCode.slice(val.pileCode.length, val.billCode.length)
        return hr
      }
    },
    jisuan() {
      return function (obj, num, fixed) {
        return (obj / num).toFixed(fixed)
      }
    },
    shifu() {
      return function (val) {
        return ((val.billMoney - val.billMoneygive) / 100).toFixed(2)
      }
    },
  },
  watch: {

  },
  created() {
    this.typings = window.sessionStorage.getItem('roleId') == 1;
    this.initMethods();
    this.startMethods();
  },
  mounted() {
    this.defaultMethods();
  },
  methods: {
    async initMethods() {
      const promises = this.quanxianlist.map(id => caozuo([id]));
      try {
        const results = await Promise.all(promises);
        this.caozuoquanxian = results[0];
        this.ownAcount = results[1];
        this.StopMoney = results[2]
        this.stopAccountStatus = results[3]
        this.daochuType = results[4]
      } catch (error) {
        console.error("权限检查出错", error);
      }
    },
    // 费控判断
    typeName(obj) {
      return !obj || obj == '' ? '--' : obj
    },
    // 类型判断
    typename1(obj) {
      return !obj || obj == '' ? '--' : obj == 0 ? '非主账户' : '主账户'
    },
    // 类型判断
    typename2(obj) {
      return !obj || obj == '' ? '--' : obj == 0 ? '对公' : '对私'
    },
    // 添加键值对
    addObj() {
      this.objValue.push({
        uniqueId: Date.now(),
        stationId: null,
        type: null,
        serviceRate: 0,
      })
      this.$forceUpdate()
    },
    editDialogClosed() {

    },
    editVinAccount() { },
    // 分账信息
    changeStationMethods() {

    },
    // 页码修改
    handleSizeChange() {

    },
    //页条修改 
    handleCurrentChange() {

    },
    // 状态修改
    stopMethods() {

    },
    // 删除附件
    delMethods() {

    },
    // 删除清分人
    delRole() {

    },
    // 冻结金额
    moneyMethods() {

    },
    // 清分明细
    detailMethods() {

    },
    // 上传附件
    uploadTil() {

    },
    // 编辑、分佣商户
    async showVinAccount(row) {
      this.title = !row || row == '' ? '分佣商户' : "编辑商户";
      this.chushihua();
      if (!row || row == '') {
        this.editDialogVisible = true;
        return
      }
      const { data: res } = await this.$http.get(`station-ledger/getStationLedgerById/${row.id}`);
      if (code > 0) {
        this.chushihua()
        return;
      }
      const target = this.allshanghu.find(item => item.id == res.data.totalLedgerId);
      this.vinAccountForm = res.data;
      const { stationIds, typeStr, stationId, type, serviceRate, serviceRateStr } = res.data;
      this.editDialogVisible = true;
      const stations = parse(stationId, stationIds);
      const types = parse(type, typeStr);
      const rates = parse(serviceRate, serviceRateStr);
      const parse = (val, str) => val ?? str?.split(',').map(Number);
      if (stationId.includes(',') || stationIds.includes(',')) {

      } else {

      }
      if (!typeStr || typeStr == '') {
        return;
      }


      that.objValue = Array.from({ length: stations.length }, (_, i) => ({
        serviceRate: rates[i],
        type: types[i],
        stationId: stations[i],
        uniqueId: Date.now() + i,
      }));
      this.defaultApimethods(target?.adminId)
      this.radio = this.vinAccountForm.isMainAccount == 1 ? '是' : '否';
      this.methodsDefault(row.stationId)
    },
    chushihua() {
      this.vinAccountForm = {
        passWord: '',
        userName: '',
        adminId: '',
        trueName: '',
        id: '',
        bankCard: '',
        bankName: '',
        type: '',
        serviceRate: '',
        des: '',
        isMainAccount: 1,
        freezeMoney: '',
        totalLedgerId: '',
        stationId: '',
        serviceRateStr: null,
        typeStr: null,
        bankBranchName: '',
        bankBranchNo: '',
        acctType: 1,
        certType: 17,
        accountKind: 58,
        bankNo: '',
      };
      this.objValue = [];
    },
    //  导出
    daochuMethods() {

    },
    // 查询
    chaxun() {

    },
    // 重置
    chongzhi() {

    },
    // 修改清分人
    change_value() {

    },
    startMethods() {
      console.log(this.currentinfo, 265);
      this.$http.get('station-total-ledger/getAllStationTotalLedger', {
        params: this.currentinfo,
      })
        .then((res) => {
          if (res.data.code !== 0) return
          this.allshanghu = res.data.data
        })
    },
    async publist() {
      const roleId = Number(window.sessionStorage.getItem('roleId'));
      if (!acn.includes(roleId)) {
        const { data: res } = await this.$http.get(
          'station-ledger/getAllStationLedger',
          { params: this.tilobj }
        )
        this.powerStationList = res.code !== 0 ? [] : res.data
        return;
      }
      let obj = {
        adminId: this.queryInfo.adminId,
        roleId,
        page: 1,
        limit: 10,
      }
      if (acn.includes(roleId) && roleId !== 5) {
        obj.IsMainAccount = 0
      }
      const { data: res } = await this.$http.get(
        'financial-overview/getAllStationLedger',
        {
          params: obj,
        }
      )
      this.powerStationList = res.code !== 0 ? [] : res.data
    },
    // 初始化
    async defaultMethods() {
      const roleId = Number(window.sessionStorage.getItem('roleId'));
      let objj = this.tilobj;
      objj.limit = 6;
      if (!acn.includes(roleId)) {
        const { data: res } = await this.$http.get(
          'station-ledger/getAllStationLedger',
          { params: objj }
        )
        if (res.code !== 0) return
        this.vinAccountList = res.data;
        this.total = res.count;
        console.log(res.data, this.vinAccountList, 331)
        return;
      }
      let obj = {
        adminId: this.queryInfo.adminId,
        roleId,
        page: 1,
        limit: 6,
      }
      if (acn.includes(roleId) && roleId !== 5) {
        obj.IsMainAccount = 0
      }
      const { data: res } = await this.$http.get(
        'financial-overview/getAllStationLedger',
        {
          params: obj,
        }
      )
      if (res.code !== 0) return
      this.vinAccountList = res.data;
      console.log(res.data, this.vinAccountList, 351)
      this.total = res.count
    }

  }
};
</script>
<style lang='less' scoped></style>